import { Link } from 'gatsby';
import * as React from 'react';
import styled, { css } from 'styled-components';
import { frontendHost } from '../../config';
import { Podcast } from '../types';
import PostImage from './PostImage';

const Wrapper = styled.div`
  a {
    position: relative;
    display: block;
    text-decoration: none;
    text-decoration: none;
    padding: 20px;
    background: rgba(249, 230, 224, 0.39);
    border-radius: 15px;

    @media (min-width: 768px) {
      position: relative;

      &::before {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        inset: 1px;
        border-radius: 20px;
        transition: background 0.2s ease 0s;
      }

      &:hover {
        &::before {
          background-color: var(--earth-fm--color--dark-beige);
        }
      }

      &:focus-visible {
        outline: 0;

        &::before {
          outline: auto;
          outline-color: var(--earth-fm--color--blue);
          background-color: var(--earth-fm--color--dark-beige);
        }
      }
    }
  }
`;

const imageWrapperIconsStyle = css`
  position: static;
  flex: auto;
  width: 100%;
  height: auto;
  margin-bottom: 31px;
`;

const ImgWrapper = styled.div<{ $forceIconsStyle: boolean }>`
  position: absolute;
  top: 20px;
  left: 20px;
  flex: 0 0 67px;
  width: 67px;
  height: 67px;
  margin: 0 20px 0 0;

  ${({ $forceIconsStyle }) => ($forceIconsStyle ? imageWrapperIconsStyle : '')}

  @media (min-width: 768px) {
    ${imageWrapperIconsStyle}
  }
`;

const titleIconsStyle = css`
  margin-bottom: 11px;
  margin-left: 0;
  font-size: 20px;
  line-height: 1.5;
`;

const Title = styled.h3<{ $forceIconsStyle: boolean }>`
  margin: -4px 0 0 87px;
  font-family: var(--earth-fm--font-family--jakarta);
  font-weight: 600;
  font-size: 18px;
  line-height: 1.5;
  min-height: 66px;

  ${({ $forceIconsStyle }) => ($forceIconsStyle ? titleIconsStyle : '')}

  @media (min-width: 768px) {
    ${titleIconsStyle}
  }
`;

const descriptionIconsStyle = css`
  font-size: 18px;
  line-height: 1.7;
  white-space: initial;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
`;

const Description = styled.p<{ $forceIconsStyle: boolean }>`
  margin: 20px 0 0;
  font-size: 14px;
  line-height: 1.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ $forceIconsStyle }) => ($forceIconsStyle ? descriptionIconsStyle : '')}

  @media (min-width: 768px) {
    ${descriptionIconsStyle}
  }
`;

interface Props {
  podcast: Podcast;
  className?: string;
  forceIconsStyle?: boolean;
}

export default function PodcastCardAlt({
  podcast: { title, uri, excerpt, featuredImage, featuredImageStyle },
  className = '',
  forceIconsStyle = false,
}: Props) {
  return (
    <Wrapper className={className}>
      <Link to={uri}>
        <ImgWrapper $forceIconsStyle={forceIconsStyle} className={`${className}__img-wrapper`}>
          <PostImage
            imageData={featuredImage}
            thumbStyle={featuredImageStyle}
            alt={`${title} - wind is the original radio podcast - ${frontendHost}`}
          />
        </ImgWrapper>
        <Title className={`${className}__title`} $forceIconsStyle={forceIconsStyle}>
          {title}
        </Title>
        {/* eslint-disable-next-line react/no-danger */}
        {excerpt && (
          <Description
            className={`${className}__description`}
            $forceIconsStyle={forceIconsStyle}
            dangerouslySetInnerHTML={{ __html: excerpt }}
          />
        )}
      </Link>
    </Wrapper>
  );
}
